export default function getLeadAssignedLinkLabel(payload: any) {
    if (
        payload.dealer_assigned_application == null ||
        payload.dealer_assigned_application.label == null
    ) {
        return ''
    }

    return ` -  ${payload.dealer_assigned_application.label}`
}
